import React from 'react'

interface NoProductsFoundProps {
  handleClearAll: () => void
}

const NoProductsFound: React.FC<NoProductsFoundProps> = ({ handleClearAll }) => {
  return (
    <div className="grid-cols-2 flex flex-col justify-start items-center body-lg text-black">
      <p>{ window.DEPT.Strings.search.noProductsFound }</p>
      <p>
        Use fewer filters or{' '}
        <button type="button" className="underline" onClick={handleClearAll}>
          remove all
        </button>
      </p>
    </div>
  )
}

export default NoProductsFound
